import { createSelector } from '@reduxjs/toolkit';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useActiveTemplateId } from './use-active-project-template';
const getProjectTemplateProjectPhase = ()=>createSelector((state)=>state.templates.project.data, (_, { projectPhaseId, templateId })=>({
            projectPhaseId,
            templateId
        }), (data, { projectPhaseId, templateId })=>data[templateId].projectPhases[projectPhaseId]);
export const useProjectTemplateProjectPhase = (projectPhaseId)=>{
    const templateId = useActiveTemplateId();
    const projectPhaseObject = useMemo(getProjectTemplateProjectPhase, []);
    return useSelector((state)=>projectPhaseObject(state, {
            projectPhaseId,
            templateId
        }));
};
